import axios from 'axios';
import store from './store/index';
export const HTTP = axios.create({
    baseURL: `https://test.wro-v.com/national_organizer/`,
    headers: {
        'Content-Type': ['application/json','multipart/form-data'],
        'Accept': 'application/json',
        'Authorization':'Bearer ' + localStorage.getItem('token'),
    }
})
